export default {
	dashboard: "Dashboard",
	users: "Users",
	consultants: "Consultants",
	mediums: "Mediums",
	functions: "Functions",
	spiritualLines: "Spiritual Lines",
	guides: "Spiritual Guides",
	orixas: "Orixás",
	ritualTypes: "Ritual Types",
	rituals: "Rituals",
	journeyStages: "Journey Stages",
	logout: "Logout",
	wisdomQuotes: "Wisdom Quotes",
	import: "Import",
	billing: "My Plan",
	manual: "Manual",
	support: "Support",
	attendanceTypes: "Attendance Types",
	displayMessages: "Display / TV",
	templeInvites: "Invites",
	templeSettings: "Settings",
};
